import React, { useState } from 'react'
import moment from 'moment'
import TokTokDocAutocomplete from './Autocomplete'
import useCitySearch from '../../hooks/useCitySearch'
import { CitySearchProps } from './_props/CitySearchProps'
import { OnAutocompleteChange, OnSelectedAutocomplete } from './_props/AutocompleteProps'
import { City } from '../../hooks/_props'

/**
 * @description City search component
 * @param {Object} props
 */
export default function CitySearch({
    onCitySearchChange,
    onSearchValueChange,
    onBlur,
    initialValue,
    error,
    disabled,
    birthDate
}: CitySearchProps) {
    const [searchText, setSearchText] = useState<string | undefined>('')

    const formatSearch = (raw: City | undefined) => {
        if (raw === undefined) return ''
        return raw?.libelle && raw?.com ? `${raw.com} (${raw.libelle})` : ''
    }

    const getSearchPhrase = () => {
        const searchBase = searchText || formatSearch(initialValue)
        const searchPhrase = searchBase.split('(')[0]
        return searchPhrase.trim().toLocaleLowerCase()
    }

    const { cities, loading } = useCitySearch({
        searchText: getSearchPhrase(),
        birthDate: birthDate ? moment(birthDate).format('YYYY-MM-DD') : undefined,
    })

    const onAutocompleteChange: OnAutocompleteChange = (_event, value) => {
        setSearchText(value)
        if (onSearchValueChange) onSearchValueChange(value)
    }
    const onSelectedAutocomplete: OnSelectedAutocomplete = (_event, value) => {
        onCitySearchChange(value)
    }

    /**
     * @description Display option values
     * @param {Array<Object>} option
     * @return {string}
     */
    const renderOption = (option: City | undefined) => {
        if (option) {
            return formatSearch(option)
        }
        return ''
    }

    return (
        <TokTokDocAutocomplete<City | undefined>
            id="city-search"
            dataCy="dataCy_city-search"
            searchText={searchText || formatSearch(initialValue)}
            value={initialValue}
            options={cities}
            loading={loading}
            error={error}
            renderOption={renderOption}
            onAutocompleteChange={onAutocompleteChange}
            onSelectedAutocomplete={onSelectedAutocomplete}
            disabled={disabled}
            variant="outlined"
            clearOnBlur
            onBlur={onBlur}
            placeholder='Rechercher un lieu'
        />
    )
}
